<template>
  <div class="h-2rem" v-if="loading"></div>
  <section
    v-else
    class="flex justify-content-center flex-column p-8 w-full"
    aria-labelledby="table-empty-title"
  >
    <div class="flex align-items-center justify-content-center">
      <CustomImage :src="emptyImage" />
    </div>

    <div class="flex align-items-center justify-content-center mt-4">
      <h3 id="table-empty-title" class="font-semibold">{{ emptyMessage }}</h3>
    </div>

    <div class="flex align-items-center justify-content-center mt-4" v-if="$slots.extraEmptyInfo">
      <slot name="extraEmptyInfo" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { Image as CustomImage } from './../../media';
import EmptyImageState from './../../data/data-table/assets/empty.svg';
defineProps({
  emptyMessage: {
    type: String,
    default: 'No data found',
  },
  loading: {
    type: Boolean,
  },
  emptyImage: {
    type: String,
    default: EmptyImageState,
  },
});
</script>

<style scoped lang="scss"></style>
